import { createContext, useContext } from 'react';
import { FilterChip } from '@voll-intelligence/ui-kit/ui/filter-chip';
import type { ApprovalsCompanyCopy } from '../approvals_copy.js';

export type ApprovalsQueueViewKind = 'mine' | 'company';

/** The admin's two queues: their own ("Para você") and every pending voucher
 *  of their company ("Toda a empresa"). The host owns the state and the fetch;
 *  the copy of everything the company view draws travels here. */
export interface ApprovalsQueueView {
  active: ApprovalsQueueViewKind;
  counts: { mine: number; company: number };
  onChange: (view: ApprovalsQueueViewKind) => void;
  copy: ApprovalsCompanyCopy;
}

/** A copy da visão da empresa para as etiquetas e os diálogos — a tela a
 *  provê a partir de `queueView`; fora dela, `null`. */
export const CompanyCopyContext = createContext<ApprovalsCompanyCopy | null>(null);

export function useCompanyCopy(): ApprovalsCompanyCopy | null {
  return useContext(CompanyCopyContext);
}

/** As duas pílulas sob o título, o mesmo chip dos filtros da fila: a ativa
 *  fica pressionada e clicar nela de novo não a desliga — sempre há uma visão. */
export function QueueViewSwitch({ view }: { view: ApprovalsQueueView }) {
  const options: { kind: ApprovalsQueueViewKind; label: string }[] = [
    { kind: 'mine', label: view.copy.viewMine },
    { kind: 'company', label: view.copy.viewCompany },
  ];
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {options.map(({ kind, label }) => (
        <FilterChip
          key={kind}
          pressed={view.active === kind}
          onPressedChange={(pressed) => {
            if (pressed && view.active !== kind) view.onChange(kind);
          }}
        >
          {label}
          <span className="text-muted-foreground tabular-nums">{String(view.counts[kind])}</span>
        </FilterChip>
      ))}
    </div>
  );
}
